export default {"src":"/_next/static/media/global-key-preview-bg.950680ba.svg","height":892,"width":1920,"blurWidth":0,"blurHeight":0};